import { classMerge } from '@components/utilities/classMerge'

export type ProgressBarProps = {
  currentStepIndex: number
  hideBackNavigation?: boolean
  numberOfSteps: number
  onBackClick?: () => void
  segment?: number
}
export function FooterProgressBar({
  currentStepIndex,
  numberOfSteps,
  segment = 1,
}: ProgressBarProps) {
  const min = Math.min(currentStepIndex, numberOfSteps)
  const numerator = min >= 0 ? min : 0
  // we want the progress bar to "fill faster" at the beginning
  const completion = Math.pow(numerator / numberOfSteps, 0.7) * 100

  const firstCompletion = segment === 1 ? completion : 100
  // eslint-disable-next-line no-nested-ternary
  const secondCompletion = segment === 2 ? completion : segment === 1 ? 0 : 100
  // eslint-disable-next-line no-nested-ternary
  const thirdCompletion = segment === 3 ? completion : segment < 3 ? 0 : 100
  const fourthCompletion = segment === 4 ? completion : 0

  return (
    <div
      className={
        'sticky z-auto mx-auto flex min-h-[40px] w-full items-center justify-between gap-2 bg-white sm:pb-8 md:top-[64px]'
      }
    >
      <div
        className={classMerge(
          'relative h-3 w-1/4 overflow-hidden bg-neutral100',
        )}
      >
        <span
          className='absolute h-3 w-full bg-primary500 transition-transform duration-500'
          id='progress-bar'
          style={{
            transform: `translateX(${firstCompletion - 100}%)`,
          }}
        />
      </div>
      <div
        className={classMerge(
          'relative h-3 w-1/4 overflow-hidden bg-neutral100',
        )}
      >
        <span
          className='absolute h-3 w-full bg-primary500 transition-transform duration-500'
          id='progress-bar'
          style={{
            transform: `translateX(${secondCompletion - 101}%)`,
          }}
        />
      </div>
      <div
        className={classMerge(
          'relative h-3 w-1/4 overflow-hidden bg-neutral100',
        )}
      >
        <span
          className='absolute h-3 w-full bg-primary500 transition-transform duration-500'
          id='progress-bar'
          style={{
            transform: `translateX(${thirdCompletion - 100}%)`,
          }}
        />
      </div>
      <div
        className={classMerge(
          'relative h-3 w-1/4 overflow-hidden bg-neutral100',
        )}
      >
        <span
          className='absolute h-3 w-full bg-primary500 transition-transform duration-500'
          id='progress-bar'
          style={{
            transform: `translateX(${fourthCompletion - 100}%)`,
          }}
        />
      </div>
    </div>
  )
}
